import { useEffect, useState } from "react";
import UpcomingMeetings from "../../components/CalendarView/UpcomingMeetings";
import { API_URL } from "../../url/api";

const Dashboard = () => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      window.location.href = "/signup?type=login";
    }
    fetch(`${API_URL}v2/user/${userId}/`)
      .then((response) => response.json())
      .then((data) => setUserName(data.name))
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className="flex bg-center max-w-5xl justify-start text-start ml-2 mt-2">
      <div className="flex-1 bg-gray-100">
        <div className=" mx-auto py-2 px-4 align-middle">
          <div className="w-full">
            <div className="mb-4 flex flex-row gap-4">
              {/* <QuoteCard /> */}
            </div>
            <div className="mb-2">
              <UpcomingMeetings />
            </div>
            <div className="mb-8">
              <h2 className="text-xl text-gray-800 mb-4">Quick Links</h2>
              <div className="bg-white shadow rounded-lg p-6">
                <ul className="space-y-4">
                  <li>
                    <a
                      href="/dashboard/appointments"
                      className="text-blue-500 hover:text-blue-700 text-md"
                    >
                      Book a New Appointment
                    </a>
                  </li>
                  <li>
                    <a
                      href="/appointment-history"
                      className="text-blue-500 hover:text-blue-700 text-md"
                    >
                      View Appointment History
                    </a>
                  </li>
                  <li>
                    <a
                      href="/dashboard/assessments"
                      className="text-blue-500 hover:text-blue-700 text-md"
                    >
                      Access Assessment Results
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* <NewsCardSection /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
